import { Routes, Route } from 'react-router-dom';
import { DashboardLayout } from './components/DashboardLayout';
import { AuthGuard } from './guards/AuthGuard';
import { DashboardPage } from './pages/DashboardPage';
import { ClientsPage } from './pages/ClientsPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { InvoicesPage } from './pages/InvoicesPage';
import { InvoiceCreatePage } from './pages/InvoiceCreatePage';
import { LeadsPage } from './pages/LeadsPage';
import { BidsPage } from './pages/BidsPage';
import { TemplatesPage } from './pages/TemplatesPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { SettingsPage } from './pages/SettingsPage';
import { BillingPage } from './pages/BillingPage';

export function App() {
  return (
    <AuthGuard>
      <Routes>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/clients/:id" element={<ClientDetailPage />} />
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/invoices/new" element={<InvoiceCreatePage />} />
          <Route path="/leads" element={<LeadsPage />} />
          <Route path="/bids" element={<BidsPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/settings/billing" element={<BillingPage />} />
        </Route>
      </Routes>
    </AuthGuard>
  );
}
